// The Angular email validator accepts an email like "rob@example", perhaps because "rob@localhost" could be valid.
// The pureEmail regex does not accept "ryan@example" as a valid email address, which I think is a good thing.
// See: EMAIL_REGEXP from https://github.com/angular/angular.js/blob/ffb6b2fb56d9ffcb051284965dd538629ea9687a/src/ng/directive/input.js#L16
const PURE_EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Passwords should be at least 8 characters long and should contain one number, one character and one special character.
// const PASSWORD_REGEXP = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
const PASSWORD_REGEXP = /^[A-Za-z\d@$!%*#?&]{8,}$/;

const MOBILE_REGEXP = /(7[0-9]{8}|10)$/;
const PHONE_REGEXP = /([0-9])$/;
const NEW_NIC_REGEXP = /^[0-9]{7}[0][0-9]{4}$/;
const OLD_NIC_REGEXP = /^[0-9]{9}[vVxX]$/;
const CHECK_WHITE_SPACE=/^[a-zA-Z0-9]*$/;
const PASSPORT_REGEXP=/^[A-Z0-9<]{9}[0-9]{1}[A-Z]{3}[0-9]{7}[A-Z]{1}[0-9]{7}[A-Z0-9<]{14}[0-9]{2}$/;
const AMOUNT =/^\d+(?:\.\d{0,2})?$/;
const NIC =/^([0-9]{9}[x|X|v|V]|[0-9]{12})$/;


export const regexValidators = {
  email: PURE_EMAIL_REGEXP,
  password: PASSWORD_REGEXP,
  mobile: MOBILE_REGEXP,
  newnic:NEW_NIC_REGEXP,
  oldnic:OLD_NIC_REGEXP,
  checkwhitespace:CHECK_WHITE_SPACE,
  passport:PASSPORT_REGEXP,
  amount:AMOUNT,
  phone:PHONE_REGEXP,
  nic:NIC
};
